import { atom as e } from "jotai";
var s = /* @__PURE__ */ ((E) => (E.SIDE_PANEL = "sidePanel", E.FULL_SCREEN = "fullScreen", E))(s || {}), I = /* @__PURE__ */ ((E) => (E.LOCALE = "locale", E.MAX_ADULTS = "maxAdults", E.MAX_CHILDREN = "maxChildren", E.IS_FULL_ADDRESS_REQUIRED = "isFullAddressRequired", E.VGS_ENVIRONMENT = "vgsEnvironment", E.GOOGLE_MAPS_ENV_KEY = "googleMapsApiKey", E.HOTEL_ID = "hotelId", E.HOTEL_NAME = "hotelName", E.HOTEL_EMAIL = "hotelEmail", E.PROPERTY_TYPE = "propertyType", E.PROPERTY_SIZE = "propertySize", E.SUBSCRIPTION_PLAN = "subscriptionPlan", E.HAS_PROMOCODE_ENABLED = "hasPromocodeEnabled", E.REGIONS = "regions", E.VIEW_LAYOUT = "viewLayout", E.CLIENT_BOOKING_TOKEN = "clientBookingToken", E.VGS_VAULT_ID = "vgsVaultId", E.GOOGLE_HOTEL_LINK = "googleHotelLink", E))(I || {});
const L = e(/* @__PURE__ */ new Map()), S = e(null, (E, _, O) => {
  const A = E(L);
  let l;
  for (l in O)
    A.set(l, O[l] || "");
  _(L, A);
}), T = (E) => e((_) => _(L).get(E) || "");
export {
  I as ConfigProperty,
  s as ViewLayout,
  L as configAtom,
  T as getConfigPropertyAtomCreator,
  S as setConfigAtom
};
